<template>
  <div class="menu-bg">
    <el-menu
      style="height: 100%;background-color: transparent;"
      :default-active="this.$page.url"
    >
      <div>
        <el-menu-item class="group flex items-center !h-10" index="/">
          <Link
            :href="zroute('app.dashboard')"
            class="flex-1 w-full overflow-hidden items-center justify-between"
          >
            <span><i class="bi bi-card-text text-xl" />
              <span>控制台</span></span>
          </Link>
        </el-menu-item>
      </div>
      <div v-if="auth.user.role !== 'company'">
        <el-menu-item class="group flex items-center !h-10" index="/company">
          <Link
            :href="zroute('app.company')"
            class="flex-1 w-full overflow-hidden items-center justify-between"
          >
            <span><i class="bi bi-card-text text-xl" />
              <span>小贷公司管理</span></span>
          </Link>
        </el-menu-item>
      </div>
      <div>
        <el-menu-item class="group flex items-center !h-10" index="/data">
          <Link
            :href="zroute('app.data')"
            class="flex-1 w-full overflow-hidden items-center justify-between"
          >
            <span><i class="bi bi-card-text text-xl" />
              <span>小贷公司经营月报管理</span></span>
          </Link>
        </el-menu-item>
      </div>
      <div v-if="auth.user.role !== 'company'">
        <el-menu-item class="group flex items-center !h-10" index="/query">
          <Link
            href="/query"
            class="flex-1 w-full overflow-hidden items-center justify-between"
          >
            <span><i class="bi bi-card-text text-xl" />
              <span>小贷公司经营情况查询</span></span>
          </Link>
        </el-menu-item>
      </div>
      <div v-if="auth.user.role ==='city' || auth.user.role === 'province'">
        <el-menu-item class="group flex items-center !h-10" index="/brief">
          <Link
            href="/brief"
            class="flex-1 w-full overflow-hidden items-center justify-between"
          >
            <span><i class="bi bi-card-text text-xl" />
              <span>简报</span></span>
          </Link>
        </el-menu-item>
      </div>
      <div>
        <el-menu-item class="group flex items-center !h-10" index="/ledger">
          <Link
            href="/ledger"
            class="flex-1 w-full overflow-hidden items-center justify-between"
          >
            <span><i class="bi bi-card-text text-xl" />
              <span>台账管理</span></span>
          </Link>
        </el-menu-item>
      </div>
      <div>
        <el-menu-item class="group flex items-center !h-10" index="/entrust">
          <Link
            href="/entrust"
            class="flex-1 w-full overflow-hidden items-center justify-between"
          >
            <span><i class="bi bi-card-text text-xl" />
              <span>委托贷款</span></span>
          </Link>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>
<script>
import VueInputAutowidth from 'vue-input-autowidth'
import {Link} from '@inertiajs/inertia-vue'

export default {
  components: {
    Link,
  },
  directives: {
    autowidth: VueInputAutowidth,
  },
  props: {
    auth: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
}
</script>
<style lang="stylus" scoped>
.name
  input
    font-size: 16px;
    margin: 15px 0;
    padding: 0 2px;
    height: 30px;
    color: #1F2D3D;
    border: 0;
    border-bottom: dashed 1px #333;
    background-color: transparent;

.menu-bg
  color: #fff;
  width: 100%
  height: 100%;
  background: #003FD2 url("../assets/left-menu-bg.png") no-repeat center top;
  background-size: 100% 100%;

  .el-menu-item
    padding 0 5px
    color #fff

    &:hover, &:hover i
      color #222

    i
      color #fff

    &.is-active
      color #222
      background: #fff

      i
        color #222

</style>
